import React from "react";
import { ReactComponent as DownloadSVG } from './download.svg';

export default function DownloadIcon({width = 16, height = 16, color = '#717182'})
{
  return (
    <DownloadSVG
      width={width}
      height={height}
      style={{stroke: color}}
    />
  );
}